import React, { useEffect, useState } from "react";
import axios from "axios";
import "../CSS/AllAPIView.css";
import ApiBuilderForm from "./ApiBuilderForm";
import APIDefinitionService from "../Services/APIDefinition";


const methodOptions = ["GET", "POST", "PUT", "DELETE"];
const fieldTypeOptions = [
  "string",
  "integer",
  "boolean",
  "number",
  "object",
  "array",
  "date",
  "date-time",
  "email",
];
const paramTypeOptions = ["query", "path"];
const authTypeOptions = ["None", "Basic Auth", "Bearer Token", "API Key"];

const AllAPIView = ({ toggleSidebar }) => {
  const [apis, setApis] = useState([]);
  const [editingApi, setEditingApi] = useState(null);
  const [projects, setProjects] = useState([]);
  const [selectedProject, setSelectedProject] = useState("");
const [basePaths, setBasePaths] = useState({
  local: "",
  server: "",
  stage: ""
});
  const [formData, setFormData] = useState({
    endpoint: "",
    method: "GET",
    summary: "",
    description: "",
    moduleName: "",
    schemaName: "",
    fields: [],
    params: [],
    headers: [],
    auth: { type: "None", username: "", password: "", token: "", apiKey: "" },
    responses: [],
  });

  const [showSuccess, setShowSuccess] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [showCreateForm, setShowCreateForm] = useState(false);
  const [expandedModules, setExpandedModules] = useState({});
  const [modules, setModules] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  const getApiById = (id) =>
  APIDefinitionService.getApiById(id);


  useEffect(() => {
    fetchApis();
    fetchProjects();
  }, []);

  const fetchApis = async () => {
    try {
      const response = await axios.get(
        "http://localhost:2011/api/definition/view"
      );
      setApis(response.data);
    } catch (error) {
      console.error("Error fetching APIs:", error);
      showErrorPopup("Failed to fetch APIs");
    }
  };

  const fetchProjects = async () => {
    try {
      const response = await axios.get("http://localhost:2011/api/projects");
      setProjects(response.data);
    } catch (error) {
      console.error("Error fetching projects:", error);
      showErrorPopup("Failed to fetch projects");
    }
  };

  const fetchProjectDetails = async (projectId) => {
  try {
    const response = await axios.get(
      `http://localhost:2011/api/projects/${projectId}`
    );

    setBasePaths({
      local: response.data.localBasePath || "",
      server: response.data.serverBasePath || "",
      stage: response.data.stageBasePath || ""
    });

  } catch (error) {
    console.error("Error fetching project details:", error);
    showErrorPopup("Failed to fetch project details");
  }
};


  const showSuccessPopup = (message) => {
    setSuccessMessage(message);
    setShowSuccess(true);
    setTimeout(() => setShowSuccess(false), 3000);
  };

  const showErrorPopup = (message) => {
    setErrorMessage(message);
    setShowError(true);
    setTimeout(() => setShowError(false), 3000);
  };

  const handleProjectChange = async (e) => {
    const projectId = e.target.value;
    setSelectedProject(projectId);
    if (projectId) {
      await fetchProjectDetails(projectId);
    } else {
setBasePaths({ local: "", server: "", stage: "" });
    }
  };

  const handleEditClick = async (api) => {
  try {
    const res = await getApiById(api.id);   // ✅ fetch FULL API

    setEditingApi(res.data);                // ✅ includes requestBody
    setSelectedProject(res.data.project?.id || "");
    setBasePaths({
  local: res.data.project?.localBasePath || "",
  server: res.data.project?.serverBasePath || "",
  stage: res.data.project?.stageBasePath || ""
   });
  } catch (error) {
    console.error("Failed to load API for edit", error);
    showErrorPopup("Failed to load API details");
  }
};



  const handleDeleteClick = async (apiId) => {
    if (window.confirm("Are you sure you want to delete this API?")) {
      try {
        await axios.delete(
          `http://localhost:2011/api/definition/delete/${apiId}`
        );
        fetchApis();
        showSuccessPopup("API deleted successfully!");
      } catch (error) {
        console.error("Error deleting API:", error);
        showErrorPopup("Failed to delete API");
      }
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFieldChange = (section, index, e) => {
    const { name, value } = e.target;
    const updatedSection = [...formData[section]];
    updatedSection[index][name] = value;
    setFormData((prev) => ({ ...prev, [section]: updatedSection }));
  };

  const handleAuthChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      auth: { ...prev.auth, [name]: value },
    }));
  };

  const handleAddItem = (section, defaultItem) => {
    setFormData((prev) => ({
      ...prev,
      [section]: [...prev[section], defaultItem],
    }));
  };

  const handleRemoveItem = (section, index) => {
    const updatedSection = [...formData[section]];
    updatedSection.splice(index, 1);
    setFormData((prev) => ({ ...prev, [section]: updatedSection }));
  };

  const handleAddResponse = () => {
    setFormData((prev) => ({
      ...prev,
      responses: [
        ...prev.responses,
        { statusCode: "", description: "", schema: "" },
      ],
    }));
  };

  const handleResponseChange = (index, e) => {
    const { name, value } = e.target;
    const updatedResponses = [...formData.responses];
    updatedResponses[index][name] = value;
    setFormData((prev) => ({ ...prev, responses: updatedResponses }));
  };

  const handleRemoveResponse = (index) => {
    const updatedResponses = [...formData.responses];
    updatedResponses.splice(index, 1);
    setFormData((prev) => ({ ...prev, responses: updatedResponses }));
  };
const handleUpdateApi = async (payloadFromForm) => {
  try {
    await APIDefinitionService.updateApiDefinition(
      editingApi.id,
      payloadFromForm   // ✅ use correct payload
    );

    setEditingApi(null);
    fetchApis();
    showSuccessPopup("API updated successfully!");
  } catch (error) {
    console.error("Error updating API:", error);
    showErrorPopup("Failed to update API");
  }
};


  const resetForm = () => {
    setFormData({
      endpoint: "",
      method: "GET",
      summary: "",
      description: "",
      moduleName: "",
      schemaName: "",
      fields: [],
      params: [],
      headers: [],
      auth: { type: "None", username: "", password: "", token: "", apiKey: "" },
      responses: [],
    });
    setSelectedProject("");
setBasePaths({ local: "", server: "", stage: "" });
  };

  const handleCancelEdit = () => {
    setEditingApi(null);
    resetForm();
  };

  const handleCancelCreate = () => {
    setShowCreateForm(false);
    resetForm();
  };

  const handleDownloadYaml = () => {
    window.open("http://localhost:2011/api/download/yaml", "_blank");
    showSuccessPopup("YAML file downloaded successfully!");
  };

  const requiresRequestBody = () => {
    return ["POST", "PUT", "PATCH"].includes(formData.method);
  };

  const requiresPathParams = () => {
    return formData.endpoint.includes("{");
  };

  // Group APIs by moduleName
  const groupedApis = apis.reduce((acc, api) => {
    const module = api.moduleName || "Uncategorized";
    if (!acc[module]) acc[module] = [];
    acc[module].push(api);
    return acc;
  }, {});

  const filteredGroupedApis = Object.fromEntries(
    Object.entries(groupedApis)
      .map(([module, moduleApis]) => [
        module,
        moduleApis.filter(
          (api) =>
            api.endpoint?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            api.summary?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            api.method?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            api.project?.name?.toLowerCase().includes(searchTerm.toLowerCase())
        ),
      ])
      .filter(([, apis]) => apis.length > 0)
  );

  // Toggle module expansion
  const toggleModule = (moduleName) => {
    setExpandedModules((prev) => ({
      ...prev,
      [moduleName]: !prev[moduleName],
    }));
  };

  //  Function passed to ApiBuilderForm for Create API
  const handleApiSubmit = async (payload) => {
    try {
await axios.post("http://localhost:2011/api/definition/save", payload);
      setShowCreateForm(false);
      fetchApis(); // refresh list
      showSuccessPopup("API created successfully!");
    } catch (error) {
      console.error("Error creating API:", error);
      showErrorPopup("Failed to create API");
    }
  };

  //  Function for cancel button
  const handleCancelForm = () => {
    setShowCreateForm(false);
    resetForm();
  };

  const fetchModules = async () => {
    try {
      const response = await axios.get("http://localhost:2011/api/modules");
      setModules(response.data);
    } catch (error) {
      console.error("Error fetching modules:", error);
      showErrorPopup("Failed to fetch modules");
    }
  };

  useEffect(() => {
    fetchApis();
    fetchProjects();
    fetchModules();
  }, []);

  const handleDeleteModule = async (moduleName) => {
    if (
      !window.confirm(`Are you sure you want to delete module "${moduleName}"?`)
    )
      return;

    try {
      // Find module ID first
      const module = modules.find((m) => m.name === moduleName);
      if (!module) {
        showErrorPopup("Module not found");
        return;
      }

      await axios.delete(
        `http://localhost:2011/api/modules/delete/${module.id}`
      );
      showSuccessPopup("Module deleted successfully!");
      fetchApis(); // refresh API list
      fetchModules(); // refresh module list
    } catch (error) {
      console.error("Error deleting module:", error);
      const msg = error.response?.data || "Failed to delete module";
      showErrorPopup(msg);
    }
  };

  return (
    <div className="api-list-container">
      <button className="hamburger" onClick={toggleSidebar}>
        ☰
      </button>

      <h2>API Documentation</h2>

      <div className="top-controls">
        <div className="project-search">
          <label>Search API:</label>
          <input
            type="text"
            placeholder="Search by endpoint, summary, method, project..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        <div className="action-buttons">
          <button className="download-btn" onClick={handleDownloadYaml}>
            Download YAML
          </button>
          <button
            className="create-btn"
            onClick={() => setShowCreateForm(true)}
          >
            Create New API
          </button>
        </div>
      </div>

      {showSuccess && <div className="success-popup">{successMessage}</div>}
      {showError && <div className="error-popup">{errorMessage}</div>}

      <div className="modules-container">
        {Object.entries(filteredGroupedApis).map(([module, moduleApis]) => (
          <div key={module} className="module-section">
            <div className="module-header">
              <h3 onClick={() => toggleModule(module)}>
                {module.toUpperCase()}
              </h3>

              <div className="module-actions">
                <span className="api-count">({moduleApis.length} APIs)</span>
                <button
                  className="delete-module-btn"
                  onClick={() => handleDeleteModule(module)}
                  disabled={moduleApis.length > 0} // Disable if module has APIs
                >
                  Delete Module
                </button>
                <span
                  className="toggle-icon"
                  onClick={() => toggleModule(module)}
                >
                  {expandedModules[module] ? "▼" : "►"}
                </span>
              </div>
            </div>

            {expandedModules[module] && (
              <table className="api-table">
                <thead>
                  <tr>
                    <th>Full Path</th>
                    <th>Method</th>
                    <th>Summary</th>
                    <th>Project</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {moduleApis.map((api) => (
                    <tr key={api.id}>
                      <td>
                        {api.project?.basePath || ""}
                        {api.endpoint}
                      </td>
                      <td>
                        <span className={`method-${api.method.toLowerCase()}`}>
                          {api.method}
                        </span>
                      </td>
                      <td>{api.summary}</td>
                      <td>{api.project?.name || "N/A"}</td>
                      <td>
                        <button
                          className="edit-btn"
                          onClick={() => handleEditClick(api)}
                        >
                          Edit
                        </button>
                        <button
                          className="delete-btn"
                          onClick={() => handleDeleteClick(api.id)}
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        ))}
      </div>

      {(showCreateForm || editingApi) && (
        <ApiBuilderForm
  onSubmit={editingApi ? handleUpdateApi : handleApiSubmit}
  onCancel={editingApi ? handleCancelEdit : handleCancelForm}
  projectId={selectedProject}
  projectBasePaths={basePaths}
  initialData={editingApi}
/>

      )}
    </div>
  );
};

export default AllAPIView;
